'use strict';
const camelCase = require('camelcase');

module.exports = function () {
	const cased = camelCase.apply(camelCase, arguments);
	return cased.charAt(0).toUpperCase() + cased.slice(1);
};
